<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{ 'Legals' | translate }}
  <button mat-icon-button [mat-dialog-close]="true" class="close-button" aria-label="close">
    <mat-icon fontIcon="close" />
  </button>
</h2>

<mat-dialog-content>
  <h2>{{ 'Licence' | translate }}</h2>
  <p [innerHTML]="'LEGAL_CONTENT_1' | translate"></p>

  <br>

  <h2>{{ 'Copyright' | translate }}</h2>
  <p>© {{ currentYear }} Christophe Le Besnerais</p>
</mat-dialog-content>
